import './flexible-section.scss';

import { ReactNode } from 'react';

import { cn } from '@sola/ark-core/utils/helpers.js';
import { SectionMeta, Themes } from '@sola/schema/lib/schema.js';

export const FlexibleSection = ({
  meta,
  children1,
  children2,
  sectionDivider,
  featureOnMobile,
  className,
}: {
  meta: SectionMeta;
  children1: ReactNode;
  children2?: ReactNode;
  sectionDivider?: ReactNode;
  featureOnMobile?: ReactNode;
  className?: string;
}) => {
  const { fullWidth, layoutRatio, anchor, overlap, theme, dividerBelow } = meta;
  const themeValue = Themes[theme].value;

  const hasSecondColumn = Array.isArray(children2)
    ? !!children2.length
    : !!children2;

  return (
    <section
      id={anchor}
      className={cn(`FlexibleSection w-full ${themeValue}-theme`, className, {
        'FlexibleSection--full': fullWidth,
        'FlexibleSection--overlap': overlap,
        'FlexibleSection--divider': dividerBelow,
        'is-two-col': hasSecondColumn,
        'has-sidebar':
          layoutRatio.includes('2-1') || layoutRatio.includes('1-2'),
      })}
    >
      {featureOnMobile && (
        <div className="FlexibleSection__container FlexibleSection__container--mobile-feature container mx-auto">
          {featureOnMobile}
        </div>
      )}
      <div
        className={cn(
          `FlexibleSection__container FlexibleSection__container--${layoutRatio} container mx-auto`,
        )}
      >
        <div className="FlexibleSection__col">{children1}</div>
        {hasSecondColumn && (
          <div className="FlexibleSection__col">{children2}</div>
        )}
      </div>
      {fullWidth && dividerBelow && sectionDivider && sectionDivider}
    </section>
  );
};
